/*** IMPORTS FROM imports-loader ***/
(function() {

define([
    'jquery',
    'mustache',
    'pip-model',
    'pip-events'
],
function(
	$,
	Mustache,
    pip,
    pipEvents
){

	var ZOOM_SIZE = 1000;
	var TIMEOUT_THRESHOLD = 15000;
	var templates = {
		threesixty_loader: $('#media__threesixty_loader').html()
	}

	function Media360Player(_media, _size, _container, autoplay) {
		this.media = _media;
		this.size = _size;
		this.mpContainer = _container;
		this.$mainImage = $(_container + ' #threesixty_' + _media.id + ' .main360Image');
		this.threesixtyDomElements = _container + ' .hint360, ' + _container + ' #threesixty_' + _media.id +' .main360Image';
		this.autoplay = autoplay;
		this.imagesInitialized = false;
		this.isLoading = false;
		this.isZoomed = false;
		this.isDragging = false;
		this.isSpinning = null;
		this.spinning = false;
		this.spinWasCancelled = false;
		this.dragTimer = 0;
		this.loadingTimer = null;
		this.loadTime = 0;
		this.imgDomain = '';
		this.imgPrefix = '';
		this.totalRows = 1;
		this.totalCols = 1;
		this.startXPosition = null;
		this.startYPosition = null;
		this.spinXGap = 0;
		this.spinYGap = 0;
		this.curRow = 1;
		this.curCol = 1;
		this.hasFullyLoaded = false;
		this.isOverlay = _container == '#mediaOverlay';
		this.totalImageCount = 0;
		this.loadedImageCounter = 0;
		this.images_for_360 = [];
		this.loadingImages = {};
		var self = this;

		this.loadSize = 400;
		if(_size.height < 1000 && _size.height > 400){
			this.loadSize = 600;
		} else if(_size.height >= 1000) {
			this.loadSize = 1000;
		}
	}


	Media360Player.prototype.launch = function launch(){
		this.loadTime = 0;
		if((!this.images_for_360.length && !this.isLoading) || !this.hasFullyLoaded){
			this.determineLoadingTime();
			this.showLoading();
			this.getJSON();
		} else {
			this.autoSpin();
		}
		this.initializeMediaListeners();
		$(this).on('IMAGES_HAVE_LOADED', $.proxy(this, 'finishedLoading'));
	};

	Media360Player.prototype.autoSpin = function autoSpin(){
		if($('#loading360').length) $('#loading360').remove();
		var self = this;
		var columnCounter = self.totalCols;
		var speed = 2000 / columnCounter;
		var verticalSpeed = 200;
		var changeVerticalRotationDirection = false;
		this.curRow = 1;
		this.isZoomed = false;

		function shouldRotateHorizontally(col){
			return col > 0;
		}

		function shouldRotateVerticallyDownwards(){
			if(self.curRow === self.totalRows) changeVerticalRotationDirection = true;
			return columnCounter === 0 && self.curRow <= self.totalRows && !changeVerticalRotationDirection;
		}

		function shouldRotateVerticallyUpwards(){
			return columnCounter === 0 && self.curRow > 1 && changeVerticalRotationDirection;
		}


		function startSpinning(speed){
			self.isSpinning = setInterval(function(){
				if(shouldRotateHorizontally(columnCounter)){
					self.curCol = columnCounter;
					self.rotateImage();
					columnCounter--;
				} else if(shouldRotateVerticallyDownwards()){
					clearInterval(self.isSpinning);
					startSpinning(verticalSpeed);
					self.curRow++;
					self.rotateImage();
				} else if(shouldRotateVerticallyUpwards()){
					self.curRow--;
					self.rotateImage();
				} else {
					clearInterval(self.isSpinning);
					self.isSpinning = null;
					self.showHint();
					self.$mainImage.addClass('openHandCursor');
					pipEvents.threeSixty.threeSixtyAutoSpinComplete.trigger();
				}
			},speed);
		}
		if(this.autoplay && !self.isSpinning){
			startSpinning(speed);
		} else if(!this.autoplay) {
			this.autoplay = true;
			self.curCol = 1;
			self.rotateImage();
		}

	};

	Media360Player.prototype.getJSON = function getJSON(){
		function findKeyLengthIn(obj){
			var count = 0;
			for(var key in obj){
				if(!/^\d+$/.test(key)){
					continue;
				}
				count++;
			}
			return count;
		}

		function baseURL(json){
			var dataURLparts = json.split('/');
			dataURLparts.pop();
			var str = dataURLparts.join('/');
			return str + '/';
		}

		pipEvents.threeSixty.threeSixtyLoadingStart.trigger();
		var self = this;

		$.ajax({
			url: this.media.json,
			dataType: 'jsonp',
			cache: true
		}).done(function(JSONdata){
			var layerCount = findKeyLengthIn(JSONdata.layers);
			for(var i = 1; i <= layerCount; i++){
				self.totalImageCount += findKeyLengthIn(JSONdata.layers[i]);
			}
			if(JSONdata && JSONdata.layers){
				$.each(JSONdata.layers,function(key, val){
					$.each(JSONdata.layers[key], function(k,v){
						self.loadImage(baseURL(self.media.json) + v + '?profile=' + self.loadSize);
					});
				});
			}
		}).fail(function(jqXHR, textStatus, errorThrown){
			pipEvents.threeSixty.threeSixtyJSONRequestError.trigger();
		});

	};

	Media360Player.prototype.loadImage = function loadImages(src){
		var self = this;
		this.loadingImages[src] = new Image();
		this.loadingImages[src].src = src;
		this.loadingImages[src].height = this.size.height;
		this.loadingImages[src].width = this.size.width;
		this.loadingImages[src].onload = function(e){
			self.images_for_360.push(self.loadingImages[src]);
			self.loadedImageCounter++;
			self.updateLoadingPercentage();
			if(self.loadedImageCounter === self.totalImageCount){
				self.hasFullyLoaded = true;
				$(self).trigger('IMAGES_HAVE_LOADED');
			}
		};
		this.loadingImages[src].onerror = function(){
			pipEvents.threeSixty.threeSixtyImageFailedToLoad.trigger(image);
		};

	};

	Media360Player.prototype.determineLoadingTime = function determineLoadingTime(){
		var self = this;
		this.isLoading = true;
		this.loadTime = 0;
		if(this.loadingTimer===null){
			this.loadingTimer = setInterval(function(){
				self.loadTime += 100;
				var percentLoaded = self.getPercentOfImagesLoaded();
				if((self.loadTime >= 5000 && percentLoaded > 75) || (self.loadTime >= 10000 && percentLoaded > 75)){
					clearInterval(self.loadingTimer);
					self.loadingTimer = null;
					$(self).trigger('IMAGES_HAVE_LOADED');
				} else if(self.loadTime >= TIMEOUT_THRESHOLD){
					clearInterval(self.loadingTimer);
					self.loadingTimer = null;
					pipEvents.threeSixty.threeSixtyTimeoutThresholdReached.trigger();
				}
			},100);
		}
	};

	Media360Player.prototype.showLoading = function showLoading(){
		var output = Mustache.render(templates.threesixty_loader);
		this.$mainImage.parent().append(output);
	};

	Media360Player.prototype.getPercentOfImagesLoaded = function getPercentOfImagesLoaded(){
		return parseInt((this.loadedImageCounter / this.totalImageCount) * 100, 10);
	};

	Media360Player.prototype.updateLoadingPercentage = function updateLoadingPercentage(){
		this.$mainImage.parent().find('#loading360Percentage').text(this.getPercentOfImagesLoaded() + "%");
	};

	Media360Player.prototype.finishedLoading = function finishedLoading(){
		clearInterval(this.loadingTimer);
		this.loadingTimer = null;
		this.isLoading = false;
		this.initializeImages();
		this.setSpinGap();
		this.$mainImage.parent().find('#loading360').fadeOut(300, function(){
			$(this).remove();
		});
		this.autoSpin();
	};

	Media360Player.prototype.initializeImages = function initializeImages(){
    	var self = this;
		$.each(self.images_for_360, function(){
			var src = $(this).attr('src');
			var fileParts = src.split('/');

			var srcPart = fileParts[fileParts.length - 1].split('_');
			var totalParts = srcPart.length;
			self.imgPrefix = src.substring(0,src.indexOf(srcPart[totalParts - 2]));
			self.totalRows = parseInt(srcPart[totalParts - 2].substring(1), 10) > self.totalRows ? parseInt(srcPart[totalParts - 2].substring(1), 10) : self.totalRows;
			self.totalCols = parseInt(srcPart[totalParts - 1].split('.')[0].substring(1), 10) > self.totalCols ? parseInt(srcPart[totalParts - 1].split('.')[0].substring(1), 10) : self.totalCols;
		});

		self.curRow = 1;
		self.curCol = self.totalCols < 24 ? Math.ceil(self.totalCols / 2) : 1;
		self.imagesInitialized = true;
	};

	Media360Player.prototype.setSpinGap = function setSpinGap(){
		var imageSize = this.size;
		this.spinXGap = imageSize.width / this.totalCols < 10 ? 10 : imageSize.width / (this.totalCols * 2);
		this.spinYGap = imageSize.height / this.totalRows > 50 ? 50 : imageSize.height / this.totalRows;
	};

	Media360Player.prototype.showHint = function showHint(){
		if(!$(this.mpContainer).find('.hint360').length){
			var imgClass = this.totalRows > 1 ? 'hint360-multiple-rows' : 'hint360-left-right';
			$(this.mpContainer).find('.threesixtyImageWrapper').append('<div class="hint360 ' + imgClass + '"></div>');
			setTimeout(function(){
				$('.hint360').fadeOut(300, function(){
					$(this).remove();
				});
			}, 3000);
		}
	};

	Media360Player.prototype.hideHint = function hideHint(){
		$(this.mpContainer).find('.hint360').fadeOut(300, function(){
			$(this).remove();
		});
	};

	Media360Player.prototype.rotateImage = function rotateImage(){
		var formatTwoDigitNumber = function formatTwoDigitNumber(val){
			return ("0" + Number(val)).slice(-2);
		};
		var	src = this.imgPrefix + "R" + formatTwoDigitNumber(this.curRow) + "_C" + formatTwoDigitNumber(this.curCol) + ".jpg?profile=" + this.loadSize;
		$(this.mpContainer + ' #threesixty_' + this.media.id +' .main360Image').attr('src',src).attr('id','threesixtyImage');
	};

	Media360Player.prototype.getZoomCSS = function getZoomCSS(mouseX, mouseY) {
		var parentOffset = $('.threesixtyImageWrapper').offset();
		var containerSize = this.isOverlay ? this.size : {height: '400', width: '400'};
		var css = {
			position: 'absolute',
			height:1000,
			width:1000
		};

		if(containerSize.height >= 1000){
			$.extend(css, {top: '50%', marginTop: -(css.height / 2)});
		} else {
			$.extend(css, {top: -((mouseY - parentOffset.top) * (1000 - containerSize.height)) / containerSize.height});
		}

		if(containerSize.width >= 1000){
			$.extend(css, {left: '50%', marginLeft: -(css.width / 2)});
		} else {
			$.extend(css, {left:  -((mouseX - parentOffset.left) * (1000 - containerSize.width)) / containerSize.width});
		}
		return css;
	};


	Media360Player.prototype.initializeMediaListeners = function initializeMediaListeners(){
		var self = this;

		$(document)
		.off('.threesixtyEvent')
		.on(TouchMouseEvent.DOWN + '.threesixtyEvent', self.threesixtyDomElements,function(e){
			e.preventDefault();

			if(pip.platform !== 'TABLET'){
				self.dragTimer = setInterval(function(){
					self.isDragging = true;
				}, 200);
			}

			self.$mainImage.removeClass('openHandCursor zoom-out').addClass('closedHandCursor');

			if(self.isSpinning) self.cancelSpin();
			self.hideHint();
			self.startXPosition = e.pageX;
			self.startYPosition = e.pageY;

			$(document).on(TouchMouseEvent.MOVE + '.threesixtyEvent', { context: self }, self.move360);
		});


		if(pip.platform !== 'TABLET'){

			$(document).on(TouchMouseEvent.UP + '.threesixtyEvent', self.threesixtyDomElements, function(e){
        var isIOS = /iPad|iPhone|iPod/.test(navigator.platform)
          || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
				var mouseX = e.pageX;
				var mouseY = e.pageY;
				self.$mainImage.removeClass('closedHandCursor zoom-out').addClass('openHandCursor');

        if(!self.isDragging && !self.spinWasCancelled && !pip.features.pinchToZoomEnabled){
					if(!self.isZoomed){
						self.zoom(mouseX, mouseY);
					} else {
						self.resetZoom();
					}
					self.isZoomed = !self.isZoomed;
				}

        if(!self.isDragging && !self.spinWasCancelled && pip.features.pinchToZoomEnabled){
          if(!isIOS) {
  					if(!self.isZoomed){
  						self.zoom(mouseX, mouseY);
  					} else {
  						self.resetZoom();
  					}
  					self.isZoomed = !self.isZoomed;
          }
				}

				clearInterval(self.dragTimer);
				self.isDragging = false;
				self.spinWasCancelled = false;
				self.startXPosition = null;
				self.startYPosition = null;
			});


			$(document).on(TouchMouseEvent.UP + '.threesixtyEvent', function(){
				clearInterval(self.dragTimer);
				self.isDragging = false;
			});
		}
	};

	Media360Player.prototype.cancelSpin = function cancelSpin(){
		clearInterval(this.isSpinning);
		this.isSpinning = null;
		this.spinWasCancelled = true;
		pipEvents.threeSixty.threeSixtyAutoSpinComplete.trigger();
	};

	Media360Player.prototype.getCurrentImageSrcWithoutSize = function getCurrentImageSrcWithoutSize(){
		var src = $(this.mpContainer + ' #threesixty_' + this.media.id +' .main360Image').attr('src');
		return src.slice(0,src.indexOf('=')+1);
	};

	Media360Player.prototype.zoom = function zoom(mouseX, mouseY){
		var self = this;
		var parentOffset = $(self.mpContainer + ' .threesixtyImageWrapper').offset();

		$(this.mpContainer + ' #threesixty_' + this.media.id +' .main360Image').attr('src', self.getCurrentImageSrcWithoutSize() + ZOOM_SIZE).hide(0,function(){
			$(this).fadeIn(200);
		});
		$(this.mpContainer + ' #threesixty_' + this.media.id +' .main360Image').css(self.getZoomCSS(mouseX, mouseY));

		$(document).on(TouchMouseEvent.MOVE + '.threesixtyMOVE', self.threesixtyDomElements,function(event) {
			var mouseX = event.pageX;
			var mouseY = event.pageY;

			self.$mainImage.removeClass('closedHandCursor openHandCursor').addClass('zoom-out');

			$(document).off('mouseleave.threesixtyEvent').on('mouseleave.threesixtyEvent', self.threesixtyDomElements, function(e){
				self.resetZoom();
				self.$mainImage.removeClass('closedHandCursor zoom-out').addClass('openHandCursor');
			});

			$(self.mpContainer + ' #threesixty_' + self.media.id +' .main360Image').css(self.getZoomCSS(mouseX, mouseY));

			self.isDragging = false;
		});
	};

	Media360Player.prototype.resetZoom = function resetZoom(){
		var self = this;
		$(this.mpContainer + ' #threesixty_' + this.media.id +' .main360Image').attr('src', this.getCurrentImageSrcWithoutSize() + this.loadSize).hide();

		setTimeout(function(){
			$(self.mpContainer + ' #threesixty_' + self.media.id +' .main360Image').css({
				position: 'relative',
				width: self.size.height,
				height: self.size.height,
				marginLeft: 'auto',
				marginRight: 'auto',
				marginTop: 0,
				top: 0,
				left: 0
			}).fadeIn(200);
			self.isZoomed = false;
		},10);

		$(document).off('.threesixtyMOVE');
		$(document).off('mouseleave.threesixtyEvent');
	};


	Media360Player.prototype.move360 = function move360(event){
		var self = event.data.context;

		if(pip.platform === 'TABLET' || self.isDragging){
			if(event.pageX > self.startXPosition){
				//spin right
				if(Math.abs(event.pageX - self.startXPosition) >= self.spinXGap){
					self.startXPosition = event.pageX;
					if(self.totalCols < 24){
						if(self.curCol < self.totalCols){
							self.curCol++;
							self.rotateImage();
						}
					} else {
						self.curCol = self.curCol == 1 ? self.totalCols : self.curCol - 1;
						self.rotateImage();
					}
				}
			} else if(event.pageX < self.startXPosition) {
				//spin left
				if(Math.abs(event.pageX - self.startXPosition) >= self.spinXGap){
					self.startXPosition = event.pageX;
					if(self.totalCols < 24){
						if(self.curCol > 1){
							self.curCol--;
							self.rotateImage();
						}
					} else {
						self.curCol = self.curCol == self.totalCols ? 1 : self.curCol + 1;
						self.rotateImage();
					}
				}
			}

			if(event.pageY < self.startYPosition) {
				//spin down
				if(Math.abs(event.pageY - self.startYPosition) > self.spinYGap){
					self.startYPosition = event.pageY;
					if(self.curRow > 1){
						self.curRow--;
						self.rotateImage();
					}
				}
			} else if(event.pageY > self.startYPosition) {
				//spin up
				if(Math.abs(event.pageY - self.startYPosition) > self.spinYGap){
					self.startYPosition = event.pageY;
					if(self.curRow < self.totalRows){
						self.curRow++;
						self.rotateImage();
					}

				}
			}
		}
	};

	return {
		create: function(_media, _size, _container, autoplay){
			return new Media360Player(_media, _size, _container, autoplay);
		}
	};

});

}.call(window));